import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrashCanSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trash-can-simple, delete, remove, garbage, waste"} maskId="square-filled-radius-0-stroke-1-IconTrashCanSimple"><path fillRule="evenodd" clipRule="evenodd" d="M8.12616 5H2.5V6H3.99896L5.03122 22H18.9688L20.001 6H21.5V5H15.8739C15.4297 3.27471 13.8641 2 12 2C10.1359 2 8.57039 3.27471 8.12616 5ZM9.17058 5H14.8295C14.4177 3.83486 13.306 3 12 3C10.6941 3 9.58233 3.83486 9.17058 5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrashCanSimple;
